import { lazy } from 'react';
import { type SurrenderRootRequest } from 'src/apis/surrender-service/use-surrender-root';
import { useSurrenderSettings } from 'src/apis/surrender-service/use-surrender-settings';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';

const Page = lazy(() => import('./page'));

type Props = {
  surrenderRoot: Successful<SurrenderRootRequest>;
};

export const SurrenderSettingsOverview = ({ surrenderRoot }: Props) => {
  const surrenderSettings = useSurrenderSettings({ surrenderRoot });

  if (!surrenderSettings?.response) return <PageSpinner />;

  return <Page surrenderSettings={surrenderSettings} />;
};
